// ─── Commercial Slice ────────────────────────────────────────────────────────
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import commercialService from '../../services/commercialService';

export const fetchSalesInvoices = createAsyncThunk('commercial/fetchInvoices', async (_, { getState }) => {
  return await commercialService.getSalesInvoices(getState().auth.token);
});
export const fetchProjects = createAsyncThunk('commercial/fetchProjects', async (_, { getState }) => {
  return await commercialService.getProjects(getState().auth.token);
});
export const fetchPriceLists = createAsyncThunk('commercial/fetchPriceLists', async (_, { getState }) => {
  return await commercialService.getPriceLists(getState().auth.token);
});
export const createInvoice = createAsyncThunk('commercial/createInvoice', async (data, { getState }) => {
  return await commercialService.createInvoice(data, getState().auth.token);
});
export const createProject = createAsyncThunk('commercial/createProject', async (data, { getState }) => {
  return await commercialService.createProject(data, getState().auth.token);
});

const commercialSlice = createSlice({
  name: 'commercial',
  initialState: {
    salesInvoices: [], projects: [], priceLists: [],
    loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesInvoices.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSalesInvoices.fulfilled, (state, action) => { state.loading = false; state.salesInvoices = action.payload; })
      .addCase(fetchSalesInvoices.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchProjects.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchProjects.fulfilled, (state, action) => { state.loading = false; state.projects = action.payload; })
      .addCase(fetchProjects.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchPriceLists.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPriceLists.fulfilled, (state, action) => { state.loading = false; state.priceLists = action.payload; })
      .addCase(fetchPriceLists.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createInvoice.fulfilled, (state, action) => { state.salesInvoices.unshift(action.payload); })
      .addCase(createProject.fulfilled, (state, action) => { state.projects.unshift(action.payload); });
  },
});

export default commercialSlice.reducer;
